import React from 'react'
import PropTypes from 'prop-types'

import { useFormChildLogic } from '../index'
import ConfirmableTimePicker from '../ConfirmableTimePicker'

const ConfirmableFormTimePicker = props => {
  const { name, validator, initValue, cypress_id } = props
  const { updateForm, value } = useFormChildLogic({
    name,
    validator,
    initValue,
  })

  return (
    <ConfirmableTimePicker
      {...props}
      value={value}
      onChange={updateForm}
      cypress_id={cypress_id}
    />
  )
}

ConfirmableFormTimePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  pickerName: PropTypes.string.isRequired,
  pickerValue: PropTypes.object,
  dialogTitle: PropTypes.string,
  dialogText: PropTypes.string,
}

export default ConfirmableFormTimePicker
